export default __webpack_public_path__ + "static/media/question-image.b66b83c3.svg";